// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d46a9411","952":"e4ab67be"}[chunkId] + ".chunk.js";
};